import { useEffect, useState, useRef } from 'react';

// Slim top progress bar that animates whenever any API request is in flight.
// Subscribes to the 'api-loading' window event emitted by lib/api.js.
export const TopLoadingBar = () => {
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(0);
  const timer = useRef(null);

  useEffect(() => {
    const onLoading = (e) => {
      const pending = e.detail || 0;
      if (pending > 0) {
        setVisible(true);
        // Creep toward 90% while requests are in flight (never completes early).
        setProgress((p) => (p < 90 ? Math.max(p, 12) : p));
        if (!timer.current) {
          timer.current = setInterval(() => {
            setProgress((p) => (p < 90 ? p + Math.max(0.5, (90 - p) * 0.08) : p));
          }, 200);
        }
      } else {
        // All done → snap to 100%, then fade out.
        if (timer.current) { clearInterval(timer.current); timer.current = null; }
        setProgress(100);
        setTimeout(() => { setVisible(false); setProgress(0); }, 350);
      }
    };
    window.addEventListener('api-loading', onLoading);
    return () => {
      window.removeEventListener('api-loading', onLoading);
      if (timer.current) clearInterval(timer.current);
    };
  }, []);

  const isClientRoute = typeof window !== 'undefined'
    && /^\/(w\/|workspace-|hirobase|client\/login|schedule\/)/.test(window.location.pathname);

  return (
    <div
      aria-hidden="true"
      data-testid="global-loading-bar"
      className="fixed top-0 left-0 right-0 z-[9999] pointer-events-none"
      style={{ height: 2.5 }}
    >
      <div
        className={`h-full ${isClientRoute
          ? 'bg-gradient-to-r from-[#1E3A34] via-[#4C7A6C] to-[#D1E2C4] shadow-[0_0_8px_rgba(30,58,52,0.45)]'
          : 'bg-gradient-to-r from-violet-500 via-sky-400 to-emerald-400 shadow-[0_0_8px_rgba(139,92,246,0.7)]'}`}
        style={{
          width: `${progress}%`,
          opacity: visible ? 1 : 0,
          transition: 'width 200ms ease-out, opacity 300ms ease-out',
        }}
      />
    </div>
  );
};

export default TopLoadingBar;
